<template>
  <div>
    <div class="language-div">
      <LanguageBar />
    </div>

    <div class="loginWrapper">
      <div class="containerSingleBox">
        <!--PAN and code box -->
        <div class="loginBox background-white">
          <div class="logo">
            <img src="../../assets/images/up.svg" />
          </div>
          <div class="loginForm">
            <div style="text-align: center;">

              <h5 class=""  > {{$t('forgotPasswordMobilPlus1')}} </h5>
              <br />
            </div>
            <div >
                <h5 class="text-justify title-mobil-plus"  > {{$t('createUserAccountTile2')}} <span class='mobil-plus'> UpMobil+ </span></h5>
                <div class='d-flex' >
                  <img width="184" height="184" src="@/assets/images/qr_mobil_plus.png" />
                  <div class="p-3">
                    <!-- <h1 class="text-justify title-mobil-plus"> {{$t('createUserAccountDescription')}} <span class='mobil-plus'> UpMobil+ </span></h1> -->
                     <h6 class="text-justify title-mobil-plus"> {{$t('createUserAccountMobilDownload')}} </h6>
                    <!-- <p v-html="$t('createUserAccountMobilDownload')" class="text-justify"></p> -->
                    <div class="text-center">
                        <p class="d-flex h-16 justify-content-space-between" >
                        <a href="https://apps.apple.com/ro/app/up-mobil/id6720748665" class="store-img">
                          <img  src="@/assets/images/a_store.svg"/>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.upromania.superup" class="store-img">
                          <img  src="@/assets/images/g_store.svg"/>
                        </a>
                        <a href="https://appgallery.huawei.com/app/C111917809" class="store-img">
                          <img src="@/assets/images/h_store.svg"/>
                        </a>
                        </p>
                      </div>
                  </div>
                </div>
                <p >
                  <h6 >{{ $t("createUserAccountDescription") }} </h6>
                </p>
                <ul>
                  <li v-for="(i, index) in 4" :key="index" class="option-plus"
                    v-html="$t('createUserAccountDescOption' + i)" ></li>
                </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LanguageBar from "@/components/LanguageBar.vue";


export default {
  components: { LanguageBar },
  name: "forgot_password",
  props: {
    msg: String,
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  },
  computed: {
  },
};
</script>
<style scoped src="@/assets/styles/login.css"></style>
<style scoped>
.mobil-plus {
  color: #F59100;
}
  .containerSingleBox {
    /* min-width: 500px; */
    /* min-width: -webkit-fill-available; */

    width: auto;
    ;
  }
  .option-plus{
    font-size: 1rem;
    margin-bottom: 0.5rem;
    line-height: 1.2;
  }
    .store-img {
    padding: 5px;
  }
    .store-img img{
    max-height: 55px;
  }
</style>
